import React from 'react';
export const PanelPickerContext = React.createContext({});
export const PanelPresetsContext = React.createContext({});
export const { Provider: PanelPickerProvider } = PanelPickerContext;
export const { Provider: PanelPresetsProvider } = PanelPresetsContext;
